module.exports = __webpack_public_path__ + "static/img/contentsPicture.c827caf.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/contentsPicture.png
// module id = yhno
// module chunks = 0